import React from 'react';
import { motion } from 'framer-motion';
import { DoubleCheck } from './Icons';
import { CTAButton } from './CTAButton';
export const Hero = () => {
  return <section className="relative flex items-center justify-center pt-12 pb-10 md:pt-20 md:pb-16 px-4 overflow-hidden md:min-h-screen" data-id="element-58">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-59">
        <div className="absolute top-1/4 left-1/4 w-64 md:w-96 h-64 md:h-96 bg-brand-red rounded-full mix-blend-screen filter blur-[128px]" data-id="element-60"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 md:w-96 h-64 md:h-96 bg-brand-blue rounded-full mix-blend-screen filter blur-[128px]" data-id="element-61"></div>
      </div>

      <div className="max-w-6xl mx-auto z-10 grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-4 md:space-y-8" data-id="element-63">
          <div className="inline-flex items-center space-x-2 bg-brand-darker border border-brand-blue/30 px-3 py-1.5 md:px-4 md:py-2 rounded-full" data-id="element-64">
            <DoubleCheck className="w-4 h-4 md:w-5 md:h-5 text-brand-blue" animate data-id="element-65" />
            <span className="text-brand-blue font-medium text-xs md:text-sm tracking-wide uppercase" data-id="element-66">
              Estrategia Comprobada
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-white uppercase" data-id="element-67">
            El Código <br data-id="element-68" />
            <span className="text-brand-red" data-id="element-69">Del Visto</span>
          </h1>

          <h2 className="text-lg md:text-2xl text-brand-light font-medium leading-tight border-l-4 border-brand-red pl-3 md:pl-4" data-id="element-70">
            El Manual Maestro para Recuperar el Poder en WhatsApp
          </h2>

          <p className="text-base md:text-lg text-brand-gray leading-relaxed" data-id="element-71">
            La estrategia de "Interrupción de Patrón" para que dejen de
            ignorarte y empiecen a perseguirte en menos de 24 horas.
          </p>

          <div className="pt-2 md:pt-4" data-id="element-72">
            <CTAButton onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-73">
              Recuperar mi poder
            </CTAButton>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-sm mx-auto lg:max-w-none" data-id="element-74">
          <div className="absolute inset-0 bg-brand-red/20 blur-3xl rounded-full" data-id="element-75"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vr4Hq96kjL2Cph3C6fdRwr/private_openrouter-generated-image-1777436960823.png" alt="El Código del Visto en Tablet" className="relative z-10 w-full h-auto object-cover border border-white/10 shadow-2xl" data-id="element-76" />
        </motion.div>
      </div>
    </section>;
};